import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import { useIsMobileQuery } from 'src/hooks/useMediaQuery'
import {
  approvedStatuses,
  dayBeforeEventHasStarted,
  isOneDayPastEvent
} from 'src/utils/helpers/EventHelperMethods'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import variables from 'src/assets/styles/variables.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import EventRegButton from './EventRegButton'
import EventTypeChip from './EventTypeChip'
import programStyles from '../programStyles.module.scss'
import QrButton from './QrButton'

// eventCardType: String, Up Next, Virtual, In-Person
// currentEvent: Boolean, optional
// largerHeight: Boolean, optional
const EventCard = ({ event, eventCardType, currentEvent, largerHeight }) => {
  const navigate = useNavigate()
  const handleViewEvent = (e) => {
    e.preventDefault()
    if (event?.is_virtual_event && event?.is_approved) {
      return window.open(event?.virtual_portal_url, '_blank')
    } else {
      return navigate(`/programs/${event?.id}`)
    }
  }
  const hasNotifications = event?.has_notifications
  const isMobileSize = useIsMobileQuery()

  return (
    <div
      className={classNames(programStyles.outerCardContainer, {
        [programStyles.upNextCardContainer]: eventCardType === 'Up Next'
      })}
      style={{
        backgroundImage: `url(${event?.background_image_web}), url(${event?.fallback_background_image_web})`,
        cursor: 'default'
      }}
    >
      <div
        className={classNames(programStyles.eventCardContainer, {
          [programStyles.largerHeight]: largerHeight,
          [programStyles.notClickable]: currentEvent
        })}
        data-testid="eventCardContainer"
      >
        <div
          className={classNames(
            generalStyles.flexColumn,
            generalStyles.fullFlex
          )}
          data-testid="eventCard"
          onClick={(e) => handleViewEvent(e)}
        >
          <div
            className={classNames(
              generalStyles.flexRow,
              generalStyles.alignVertical
            )}
          >
            <EventTypeChip eventCardType={eventCardType} color={'white'} />
            {!isMobileSize && (
              <span
                className={fontStyles.pxsmallboldlssinneutral01whitegartnersans12pt}
                data-testid="eventDate"
              >
                {event?.formatted_date_range}
              </span>
            )}
            {isMobileSize && (
              <div
                className={classNames(
                  generalStyles.flexRow,
                  generalStyles.alignVertical
                )}
              >
                <span
                  className={fontStyles.pxsmallboldlssinneutral01whitegartnersans12pt}
                >
                  {event?.formatted_date_range}
                </span>
              </div>
            )}
            {hasNotifications && (
              <div
                className={programStyles.alertContainer}
                data-testid="eventNotice"
              >
                <IcomoonReact
                  iconSet={rebrandIconSet}
                  color={variables.white}
                  size={isMobileSize ? 22 : 24}
                  icon="Alert"
                />
              </div>
            )}
          </div>
          <div
            className={classNames(
              programStyles.eventName,
              generalStyles.flexColumn,
              generalStyles.mb10,
              generalStyles.mt10
            )}
          >
            <span
              className={classNames(fontStyles.h4lightlsinneutral01whitegartnersans23pt)}
              data-testid="eventNameLine1"
            >
              {event?.region_name}
            </span>
            <span
              className={classNames(fontStyles.h4lightlsinneutral01whitegartnersans23pt)}
              data-testid="eventNameLine2"
            >
              {event?.joined_brand_names} Community
            </span>
            <span
              className={classNames(
                fontStyles.h4lsinneutral01whitegartnersans23pt,
                generalStyles.mb10
              )}
              data-testid="eventNameLine3"
            >
              {event?.product_name}
            </span>
            {currentEvent && (
              <span
                className={classNames(
                  fontStyles.pxsmallboldlssinneutral01whitegartnersans12pt,
                  generalStyles.defaultCursor
                )}
                data-testid="eventDetails"
              >
                {event?.is_virtual_event
                  ? event?.formatted_time + ' ' + event?.timezone_abbreviation
                  : event?.venue_name}
              </span>
            )}
          </div>
        </div>
        <div
          className={classNames(generalStyles.flexRow, generalStyles.flexApart)}
        >
          {currentEvent &&
          approvedStatuses(event) &&
          dayBeforeEventHasStarted(event) &&
          !event?.is_virtual_event ? (
            <QrButton event={event} />
          ) : // if event has passed, show no reg CTA
          // Do not remove CTA if event card is 'Up Next' type
          isOneDayPastEvent(event) && eventCardType !== 'Up Next' ? (
            ''
          ) : (
            <EventRegButton
              event={event}
              eventCardType={eventCardType}
              handleViewEvent={handleViewEvent}
              currentEvent={currentEvent}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default EventCard
